import { Component } from 'react';
import { connect } from 'react-redux';
import { actions } from 'forms/rrf';
import { Col, Container, Row } from 'react-bootstrap';
import PageTitle from '../common/page-title';
import InlineCKEditor from '../common/editor/inline-editor';
import PersonalRewardsStatement from './personal-rewards-statement';
import { loadPageContent } from '../../actions/content';
import { initialStates } from '../../initialStates';
import { getOutletsForPointsStatement } from '../../actions/points-statement';
import { checkPermission } from '../common/guards/can';
import './styles.css';

class PointsStatement extends Component {
  constructor(props) {
    super(props);

    this.pageSlug = 'points-statement';
  }

  componentDidMount() {
    const { dispatch } = this.props;
    dispatch(getOutletsForPointsStatement());
    dispatch(actions.load('deep.points_statement', initialStates.point_statement));
    dispatch(loadPageContent(`api/pages/${this.pageSlug}`));
  }

  handleContentSaved = () => {
    this.props.dispatch(loadPageContent(`api/pages/${this.pageSlug}`));
  };
  render() {
    return (
      <Container fluid className="points-statement user-inner-container">
        <Row>
          <Col className="points-statement-title" lg={12}>
            <PageTitle>Points Statement</PageTitle>
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <InlineCKEditor
              identifier={`${this.pageSlug}_content_text`}
              onContentSaved={this.handleContentSaved}
              contents={this.props.contents[`${this.pageSlug}_content_text`]}
            />
          </Col>
        </Row>
        <Row>
          <Col lg={12} className="points-statement-tabs">
            {checkPermission('view', 'web_app_personal_statement') && (
              <PersonalRewardsStatement/>
            )}
          </Col>
        </Row>
      </Container>
    );
  }
}

const mapStateToProps = state => ({
  contents: state.content.list,
  profile: state.viewConfig.profile,
  stores: state.points_statement.outlets,
});

export default connect(mapStateToProps)(PointsStatement);
